






import { PropType } from 'vue';
import { InstitutionProfileModel } from '../models/institutionProfile.model';
import ContactPopover from '../../src/components/contacts/ContactPopover.vue';

export default {
  components: { ContactPopover },
  props: {
    profile: { type: Object as PropType<InstitutionProfileModel>, required: true },
  },
  computed: {
    id() {
      return `mention-${this.profile.id}`;
    },
    name() {
      return this.profile.fullName || this.profile.name;
    },
  },
  methods: {
    handleProfileClicked() {
      this.$router.push({ name: 'userview', params: { id: this.profile.id } });
    },
  },
};
